module.exports = __webpack_public_path__ + "static/media/dashboard.9177d4d7.gif";